import { safeInternalPath } from './safeInternalPath';

/**
 * Frases que abandonam o fluxo guiado em andamento. Sem isso o próximo envio
 * ressuscita o rascunho que o usuário acabou de largar.
 * @param {string} text
 * @returns {boolean}
 */
export function startsNewFlow(text) {
  return /^(quero |o que |quais |cancelar|i want |what can |what do |cancel)/i.test(
    String(text || '').trim(),
  );
}

/**
 * Pílulas de atalho só no menu ou ao preencher um campo. Qualquer outra
 * resposta que traga o menu da intenção reabre o mesmo clique e vira loop.
 * O menu persistente do compositor fica fora desta função.
 * @param {{menu?: boolean, showMenu?: boolean, slot?: object, choices?: Array}} msg
 * @param {Array} fallbackMenu
 */
export function choicesForMessage(msg, fallbackMenu = []) {
  if (!msg || msg.role === 'user') return [];
  if (msg.slot && msg.choices?.length) return msg.choices;
  if (msg.menu || msg.showMenu) return msg.choices?.length ? msg.choices : fallbackMenu;
  return [];
}

export function visibleActions(actions) {
  const seen = new Set();
  const out = [];
  (actions || []).forEach((action) => {
    const path = safeInternalPath(action?.path);
    if (!path || seen.has(path)) return;
    seen.add(path);
    out.push({ label: action.label, path });
  });
  return out;
}
